// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2e4Ll","right":"Footer_right__2rCHi","buttons":"Footer_buttons__3VbOa"};